import './whatsapp_media_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappVoiceMessageContent extends Monitoring.Models.SocialContents.WhatsappMediaMessageContent


  getMainText: ->
    ""
